import React from 'react'
import {useDispatch} from 'react-redux'
import classnames from 'classnames'
import { selectItem, deselectItem } from '../../../actions/contents/template'
import EntryItemCheckbox from "../../common/EntryItemCheckbox"
import {addPrefix} from "../../../utils/UriUtil"


function TemplateItemTitle({item}) {
  const url = (item.deleting || !item.editable) ? "#" : addPrefix("/manage/template/" + item.id)

  function handleClick(e) {
    if (item.isRestrict) {
      e.preventDefault()
      alert('규제된 게시글은\n삭제만 가능합니다.');
    }
  }

  return (
    <strong className="tit_post tit_ellip">
      <a href={url} title={item.title} className="link_cont" onClick={handleClick}>
        {item.isRestrict && <span className="txt_tag">[{item.restrictLabel}]</span>}
        {item.title}
      </a>
      {item.hasFile && <span className="ico_blog ico_file"/>}
    </strong>
  )
}

export default function TemplateListItem({item}) {
  const dispatch = useDispatch()

  function handleSelectItem(id) {
    dispatch(selectItem(id))
  }

  function handleDeselectItem(id) {
    dispatch(deselectItem(id))
  }

  function handleChange(e) {
    if (item.selected) {
      handleDeselectItem(item.id)
    } else {
      handleSelectItem(item.id)
    }
  }

  return (
    <li className={classnames({item_dimmed:item.deleting})}>
      <EntryItemCheckbox item={item} handleSelect={handleChange} />

      <div className="post_cont">
        <TemplateItemTitle item={item} />
        <span className="txt_info fst">{item.author}</span>
        <span className="txt_info">{item.published}</span>
      </div>
    </li>
  )
}
